const url = "https://co-lancer-backend.vercel.app"

module.exports = url;